import SectionHeading from '@/components/base/SectionHeading';
import ScrollReveal from '@/components/base/ScrollReveal';
import { demoTutorials } from '@/mocks/mt4mt5Page';

export default function DemoSection() {
  return (
    <section id="demo" className="scroll-mt-24 border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <SectionHeading
          eyebrow="ลงมือทำตาม"
          title="เรียนรู้การใช้งานแพลตฟอร์มทีละขั้นตอน"
          subtitle="สองเครื่องมือที่ใช้บ่อยที่สุดในการเตรียมกราฟก่อนตัดสินใจ เริ่มจากเวอร์ชันที่คุณใช้อยู่ แล้วทำตามทีละขั้นบนบัญชีทดลอง"
        />

        <div className="mt-10 flex flex-col gap-8 md:gap-6">
          {demoTutorials.map((demo, index) => {
            const isReversed = index % 2 === 1;
            return (
              <ScrollReveal key={demo.slug} delay={index * 80}>
                <article className="grid grid-cols-1 items-center gap-6 rounded-xl border border-background-200 bg-background-100/40 p-5 md:gap-6 md:p-6 lg:grid-cols-12 lg:gap-8">
                  <div className={`lg:col-span-7 ${isReversed ? 'lg:order-2' : 'lg:order-1'}`}>
                    <figure className="overflow-hidden rounded-lg border border-background-200 bg-background-50 p-2">
                      <div className="flex items-center justify-between px-1 pb-2">
                        <span
                          className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${
                            demo.platform === 'MT4'
                              ? 'bg-primary-500 text-background-50'
                              : 'bg-accent-500 text-background-50'
                          }`}
                        >
                          {demo.platform}
                        </span>
                        <span className="rounded-full bg-background-100 px-2.5 py-0.5 text-[11px] font-medium text-foreground-600">
                          {demo.badge}
                        </span>
                      </div>
                      <div className="h-[200px] w-full overflow-hidden rounded-md md:h-[280px]">
                        <img
                          src={demo.image}
                          alt={`${demo.caption} ของ ${demo.platform} ประกอบบทความ ${demo.title}`}
                          title={`${demo.title} - คู่มือ ${demo.platform}`}
                          className="h-full w-full object-cover object-top"
                        />
                      </div>
                      <figcaption className="px-1 pt-2 text-[11px] leading-relaxed text-foreground-500 md:text-xs">
                        {demo.caption}
                      </figcaption>
                    </figure>
                  </div>

                  <div className={`lg:col-span-5 ${isReversed ? 'lg:order-1' : 'lg:order-2'}`}>
                    <p className="flex items-center gap-2 text-[11px] font-semibold text-foreground-500">
                      <i className="ri-cursor-line text-sm text-primary-600" />
                      ขั้นตอนสั้น ๆ บน {demo.platform}
                    </p>
                    <h3 className="mt-2 font-heading text-lg font-semibold leading-snug text-foreground-950 md:text-xl">
                      {demo.title}
                    </h3>
                    <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{demo.description}</p>

                    <ol className="mt-4 flex flex-col gap-2.5">
                      {demo.steps.map((step, stepIndex) => (
                        <li key={step} className="flex items-start gap-2.5">
                          <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-100 font-num text-[10px] font-semibold text-primary-700">
                            {stepIndex + 1}
                          </span>
                          <span className="text-sm leading-relaxed text-foreground-700">{step}</span>
                        </li>
                      ))}
                    </ol>

                    <p className="mt-5 flex items-start gap-2 rounded-md border border-background-200 bg-background-50 px-3 py-2.5 text-[12px] leading-relaxed text-foreground-600">
                      <i className="ri-lightbulb-line mt-0.5 text-sm text-accent-600" />
                      ลองทำตามบนบัญชีทดลองก่อน เพื่อให้คุ้นมือโดยไม่ต้องใช้เงินจริง
                    </p>
                  </div>
                </article>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}